<template>
  <div>
    <v-container>
      <v-data-table ref="blockUsers"
        :headers="headers"
        :items="filteredUsers"
        :pagination.sync="pagination"
        class="elevation-1 ex-product-table"
        hide-actions
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr>
            <td @click="$router.push('/accounts/' + props.item.id)" class="text-xs-center">
              <v-list-tile-avatar>
                <img :alt="$t('avatar')" :src="apiUrl + props.item.avatar" v-if="props.item.avatar"/>
                <img :alt="$t('avatar')" src="../../../assets/images/NoImage.png" v-else/>
              </v-list-tile-avatar>
            </td>
            <td @click="$router.push('/accounts/' + props.item.id)" class="text-xs-left">
              <span>{{ props.item.firstName}} {{ props.item.lastName}}</span>
            </td>
            <td  class="text-xs-left">
              <span> {{props.item.email}}</span>
            </td>
            <td>
              <v-btn  flat class="send-verification-btn" @click="blockModal(props.item)">{{$t('settings.un_block')}}</v-btn>
            </td>
          </tr>
          <v-dialog max-width="500px" v-model="blockDialog">
            <v-card-title>
              <span class="headline ml-5">{{$t('all_ip')}}</span>
            </v-card-title>
            <div class="row ml-4">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-4 offset-md-2"
                       v-for="(item) in allIp"
                       :key="item.id"
                  >{{ item.userIp }}
                    <v-btn @click.native="unBlockUserIp(item.userIp)" class="block g-btn-main-light g-btn-135 m-0-5">
                       <span  v-bind:style="item.block === false ? 'opacity:  0.5' : ''"> {{$t('un_block')}}</span>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="closeModal" class="g-btn-default g-btn-135 m-0-5">{{$t('settings.cancel')}}
              </v-btn>
            </v-card-actions>
          </v-dialog>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2" v-if="this.users.length > 10">
        <v-pagination
          :length="pages"
          :total-visible="7"
          v-model="pagination.page"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'BlockedUsers',
  data: () => ({
    allIp: {},
    users: [],
    blockDialog: false,
    apiUrl: process.env.ROOT_API,
    pagination: {
      page: 1,
      rowsPerPage: 10
    },
    selected: [],
    visibleType: null
  }),
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    }),
    filteredUsers () {
      return this.users.filter((i) => {
        return this.visibleType === null || (i.status === this.visibleType)
      })
    },
    headers () {
      return [
        { text: this.$t('settings.users'), value: 'avatar', sortable: false },
        {
          text: this.$t('settings.name'),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: this.$t('settings.email'), align: '', value: 'email', sortable: false },
        { text: this.$t('settings.actions'), align: 'center', value: 'actions', sortable: false }

      ]
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0
      return Math.ceil(this.users.length / this.pagination.rowsPerPage)
    }
  },
  methods: {
    blockModal (item) {
      this.blockUser = item
      this.blockDialog = true
      this.$store.dispatch('auth/getUserIps', {id: item.id}).then((res) => {
        if (res) {
          this.allIp = res.userIps
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      })
    },
    unBlockUserIp (ip) {
      if (this.blockUser) {
        this.blockDialog = false
        let data = {
          id: this.blockUser.id,
          ip: ip,
          block: true
        }
        this.$store.dispatch('auth/toggleBlockUserIp', data).then((res) => {
          if (res) {
            this.getBlockUsers()
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    },
    closeModal () {
      this.blockDialog = false
    },
    getBlockUsers () {
      this.$store.dispatch('auth/getBlockUsers').then((res) => {
        this.users = res.getAllBlockUsers
      }).catch(console.error)
    }
  },
  created () {
    this.getBlockUsers()
  },
  mounted () {
    this.$refs.blockUsers.$el.querySelector('.v-table__overflow').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.blockUsers.$el.querySelector('.v-table__overflow').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
  .reset {
    color:white;
    text-transform: capitalize;
  }
    .tabHeader {
        color: #5964db;
        font-size: 34px;
        font-weight: 600;
    }
    .gray {
      opacity: 0.5;
      color: grey !important;
    }
  .block {
    margin-bottom: 7px!important;
    margin-left: 180px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/BlockedUsers.vue